import React, { Component } from 'react'
import { withFirebase } from './Firebase';
import { withRouter } from "react-router-dom";
//import ImageUploader from 'react-images-upload';

class GalleryBase extends Component {

    constructor(props) {
        super(props);

        this.state = { 
             photos: []
        };

        this.handleChangeReference = this.handleChangeReference.bind(this);
        this.uploadImage = this.uploadImage.bind(this);
    }

    /**
     * Takes base64 image or path and load to canvas
     * 
     * @param {string} imageBase Base64 Image or Image Path
     */
    handleChangeReference(index) {
        this.props.changeReference(index);
        this.props.history.push('/picker');
    }

    uploadImage(e) {
        var _this = this;
        var reader = new FileReader();
        reader.onload = function(e){
            _this.props.addReference(e.target.result)
        }
        reader.readAsDataURL(e.target.files[0]);
    }

    render() {

        return (
            <div className="mb-8 mt-4 mx-6">
                
                <div className="bg-white shadow sm:rounded-lg">
                    <div className="px-4 py-5 sm:p-6">
                        <h3 className="text-lg leading-6 font-medium text-gray-900">
                            Upload Reference to Gallery
                        </h3>
                        <div className="mt-2 max-w-xl text-sm leading-5 text-gray-500">
                            <p>
                                Any reference that you'll use in your painting.
                            </p>
                        </div>
                        <div className="mt-5 sm:flex sm:items-center">
                            <div className="max-w-xs w-full">
                                <label htmlFor="email" className="sr-only">Email</label>
                                <div className="relative rounded-md shadow-sm">
                                    <input type="file" className="form-input block w-full sm:text-sm sm:leading-5" id="imageLoader" onChange={this.uploadImage} name="imageLoader"/>
                                </div>
                            </div>
                            <span className="mt-3 inline-flex rounded-md shadow-sm sm:mt-0 sm:ml-3 sm:w-auto">
                                <button type="button" className="w-full inline-flex items-center justify-center px-4 py-2 border border-transparent font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition ease-in-out duration-150 sm:w-auto sm:text-sm sm:leading-5">
                                    Upload
                                </button>
                            </span>
                        </div>
                    </div>
                </div>

                {/*<input name="file" type="file"
                className="file-upload" data-cloudinary-field="image_id"
                data-form-data="{ 'transformation': {'crop':'limit','tags':'samples','width':600,'height':800}}"/>*/}
                <ul className="mt-4 grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
                    { 
                        this.props.references.map((ref, index) => (
                            <li key={index} className="col-span-1 flex flex-col text-center bg-white shadow cursor-pointer">
                                <img src={ref} onClick={() => this.handleChangeReference(index)} alt="Gallery Item" />
                            </li>
                        ))
                    }
                </ul>
            </div>
        );
    }
}

const Gallery = withRouter(withFirebase(GalleryBase));

export default Gallery;